import script from "./ProjectDate.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectDate.vue?vue&type=script&setup=true&lang=js"

import "./ProjectDate.vue?vue&type=style&index=0&id=74b98962&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74b98962"]])

export default __exports__